__turbopack_context__.v({
  "badge": "jx6Gfq_badge",
  "bordered": "jx6Gfq_bordered",
  "circle": "jx6Gfq_circle",
  "filled": "jx6Gfq_filled",
  "pin": "jx6Gfq_pin",
  "pinShape": "jx6Gfq_pinShape",
});
